export const textOptions = [
  {
    label: 'Alt text',
    value: 'alt text',
  },
  {
    label: 'Long Text',
    value: 'long text',
  },
  {
    label: 'Meta Description',
    value: 'meta description',
  },
  {
    label: 'Meta Title',
    value: 'meta title',
  },
  {
    label: 'Page Title',
    value: 'page title',
  },
  {
    label: 'Paragraph',
    value: 'paragraph',
  },
  {
    label: 'Sentence',
    value: 'sentence',
  },
  {
    label: 'Short Text',
    value: 'short text',
  },
  {
    label: 'Story',
    value: 'story',
  },
  {
    label: 'Title',
    value: 'title',
  },
]
